import { defineMessages } from 'react-intl';

export const labelMessages = defineMessages({
  printerListsFailed: {
    description: 'Failed to fetch Printers data',
    defaultMessage: 'Failed to fetch Printers'
  },
  invoiceLocked: {
    description: 'Message for one invoice locked',
    defaultMessage: 'Invoice Locked'
  },
  invoicesLocked: {
    description: 'Message for invoices locked',
    defaultMessage: 'Invoices Locked'
  },
  invoiceUnlocked: {
    description: 'Message for one invoice unlocked',
    defaultMessage: 'Invoice Unlocked'
  },
  invoicesUnlocked: {
    description: 'Message for invoices unlocked',
    defaultMessage: 'Invoices Unlocked'
  },
  printedInvoiceUnlocked: {
    description: 'Message for one invoice unlocked',
    defaultMessage: 'The check has been posted to the general ledger.'
  },
  printedInvoicesUnlocked: {
    description: 'Message for one or more invoices unlocked',
    defaultMessage: 'The checks have been posted to the general ledger.'
  }
});

export const errorMessages = defineMessages({
  updateLockStatus: {
    defaultMessage: 'Unable to update invoice lock status',
    description: 'Error message for locking invoices'
  },
  invoicesNotLocked: {
    defaultMessage: '{number} invoice(s) failed to lock',
    description: 'Error message for invoices not locked'
  },
  invoicesNotUnlocked: {
    defaultMessage: '{number} invoice(s) failed to unlock',
    description: 'Error message for invoices not unlocked'
  },
  lockStatusFetch: {
    defaultMessage: 'Unable to fetch lock statuses',
    description: 'Error message for fetching invoice lock statuses'
  },
  apiError: {
    defaultMessage:
      'Print Checks tab failed to load due to system error. Please try again.',
    description: 'Error message for API failure'
  },
  printChecksApiError: {
    defaultMessage:
      'Checks failed to print. Please retry in a few moments. If issue persists, please contact CDK Support.',
    description: 'Error message for print checks API failure'
  },
  virtualCardApiError: {
    defaultMessage:
      'Virtual card payment failed. Please retry in a few moments. If issue persists, please contact CDK Support.',
    description: 'Error message for virtual card payment API failure'
  },
  glCalendarApiError: {
    defaultMessage:
      'Accounting setups for GL Calendar are missing or unavailable. Please wait and retry. If issue persists, contact CDK Support for onboarding to AP Payments.',
    description: 'Error message for gl calendar API failure'
  }
});
